module.exports = __webpack_public_path__ + "static/media/icon-xls.46e4448a.svg";